import { render, staticRenderFns } from "./StudentInfomation.vue?vue&type=template&id=30e6b58c"
import script from "./StudentInfomation.vue?vue&type=script&lang=js"
export * from "./StudentInfomation.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./StudentInfomation.vue?vue&type=style&index=1&id=30e6b58c&prod&lang=scss"
import style2 from "./StudentInfomation.vue?vue&type=style&index=2&id=30e6b58c&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports